export function getBoolean(
  value: string | undefined,
  name: string,
  defaultValue?: boolean,
): boolean {
  if (value !== undefined && value !== '') {
    if (value === 'true') {
      return true;
    }

    if (value === 'false') {
      return false;
    }
  }

  if (defaultValue !== undefined) {
    return defaultValue;
  }

  throw new Error(
    `Invalid value '${value}' for boolean environment variable in mode '${import.meta.env.MODE}': ${name}`,
  );
}

export function getNumber(
  value: string | undefined,
  name: string,
  defaultValue?: number,
): number {
  if (value !== undefined && value !== '') {
    const parsed = parseInt(value, 10);
    if (isNaN(parsed)) {
      throw new Error(
        `Invalid value '${value}' for number environment variable in mode '${import.meta.env.MODE}': ${name}`,
      );
    }
    return parsed;
  }

  if (defaultValue !== undefined) {
    return defaultValue;
  }

  throw new Error(
    `Invalid value '${value}' for number environment variable in mode '${import.meta.env.MODE}': ${name}`,
  );
}

export function getString(
  value: string | undefined,
  name: string,
  defaultValue?: string,
): string {
  if (value !== undefined && value !== '') {
    return value;
  }

  if (defaultValue !== undefined) {
    return defaultValue;
  }

  throw new Error(
    `Invalid value '${value}' for string environment variable in mode '${import.meta.env.MODE}': ${name}`,
  );
}
